// Inside draft-convert this is used to convert draft contentState (required param) to raw serialized state.
// We already have raw state (as returned from the API), so we'd like to pass that right to draft-convert
// so we make that line a noop by forcing it to use this module instead of the real draft-js one.
export var convertToRaw = function convertToRaw(contentState) {
  return contentState;
};


// WEBPACK FOOTER //
// ./__mocks__/draft-js.js